export const CASE_SUMMARY_TITLE = "AI documentation summary";

/** Provenance shown on notes mapped from this panel in Report Builder. */
export const CASE_SUMMARY_SOURCE_NAME = "Documentation summary";

/**
 * The document's own wording, per the MEDirect Documentation Summary Brand
 * Guidelines: letterhead, title and footer.
 */
export const CASE_SUMMARY_DOCUMENT = {
  kind: "Documentation Summary",
  kindDetail: "Pre-Assessment Medical Documentation Compilation",
  productLine: "Report Studio · Doc Prep",
  title: "Documentation Summary",
  footer: [
    "End of Documentation Summary",
    "MEDirect Report Studio — Doc Prep",
    "Strictly confidential — for Medical Expert use only",
  ],
};

/**
 * The About block. An AI-generated document must say so, say it isn't
 * clinical opinion, and say the sources need reviewing independently.
 */
export const CASE_SUMMARY_ABOUT = {
  generated:
    "This summary is AI-generated by MEDirect Report Studio from the documents provided for this case.",
  notOpinion: "It does not constitute clinical opinion.",
  review:
    "All source documents should be reviewed independently by the Medical Expert.",
};

/**
 * Stand-in body until the case-level summary is generated (MDRS-486 ships the
 * window only; generation is tracked separately). Follows the reference
 * summary's sections, deliberately generic — no sample patient details — and
 * labelled as a placeholder in the text itself.
 */
export const CASE_SUMMARY_PLACEHOLDER = {
  subtitle: "Placeholder content — the summary for this case is not generated yet.",
  notice:
    "Placeholder: the summary for this case hasn't been generated yet, so each section below describes what it will contain.",
  sections: [
    {
      number: "1",
      title: "Matter Overview",
      body: "The claimant, the instructing party, the claim type and jurisdiction, and the questions posed in the letter of instruction.",
    },
    {
      number: "2",
      title: "Documents Reviewed",
      body: "Every document in the case bundle with its date and author, any documents excluded, and gaps apparent on the face of the bundle.",
    },
    {
      number: "2A",
      title: "Assessment-Type Document Checklist",
      body: "The documents expected for this type of assessment, each marked present, partial or absent.",
    },
    {
      number: "3",
      title: "Pre-Injury Baseline",
      body: "Occupational history, functional status, prior injuries and conditions, psychological and substance use history, and family and social context.",
    },
    {
      number: "4",
      title: "The Reported Injury and Its Setting",
      body: "Date and location, the circumstances, immediate symptoms and the initial medical presentation.",
    },
    {
      number: "5",
      title: "History Since the Reported Injury",
      body: "Specialist reviews, hospitalisation, allied health, procedures, medication history and any deterioration, in date order.",
    },
    {
      number: "6",
      title: "Investigations Summary",
      body: "Imaging, pathology and other investigations, with their key findings.",
    },
    {
      number: "7",
      title: "Current Reported Symptoms",
      body: "Physical and psychological symptoms, and their functional impact as reported.",
    },
    {
      number: "8",
      title: "Current Treatment and Medications",
      body: "Current treating practitioners, medications and therapy, and treatment recommended but not yet started.",
    },
    {
      number: "9",
      title: "Work Capacity",
      body: "Current work status and treating clinicians' opinions on capacity.",
    },
    {
      number: "10",
      title: "Activities of Daily Living",
      body: "Domestic and self-care activities, mobility, social participation and care needs.",
    },
    {
      number: "11",
      title: "Psychological and Social History",
      body: "Developmental and mental health history, diagnoses cited in the documents, and risk.",
    },
    {
      number: "12",
      title: "Contradictions and Inconsistencies",
      body: "Factual discrepancies between documents, each stated with the documents it comes from.",
    },
    {
      number: "13",
      title: "Flags for Medical Expert",
      body: "Missing documents, gaps in the record and matters to clarify, most consequential first.",
    },
    {
      number: "13A",
      title: "Assessment-Type Specific Flags",
      body: "Flags that apply to this type of assessment.",
    },
  ],
};
